module.exports = __webpack_public_path__ + "static/img/1.e4ff92a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/1.png
// module id = A3vX
// module chunks = 0